import React from 'react';

import cn from 'classnames';

interface IProps {
  children: React.ReactNode[] | React.ReactNode;
  className?: string;
  allowOverflow?: boolean;
  [other: string]: any;
}

const Card = ({ children, className, allowOverflow, ...props }: IProps) => {
  return (
    <div
      className={cn(
        'Card shadow-card bg-soft-sensual-audios rounded-lg overflow-hidden',
        className,
        { 'overflow-visible': allowOverflow },
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
